import i18n from '@/i18n';
import { getToken } from '@future-harry/nxt-keycloak';
import axios, { AxiosResponse } from 'axios';
import { useAppStore } from '../collections/app.store';
import { checkBackendVersion } from '../helpers/cache.helper';
import router from '../../apps/admin/router';

const authRequestInterceptor = async function (config: any) {
   const token = await getToken();

   config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      Accept: `application/json`,
   };

   return config;
};

const authResponseSuccessInterceptors = async function (response: AxiosResponse) {
   try {
      const backendVersion = response.headers['x-api-version'];
      checkBackendVersion(backendVersion);
   } catch {
      console.warn('Error while getting backend version');
   }
   return response;
};

const authResponseErrorInterceptors = async function (error: any) {
   const { isDev } = useAppStore();

   if (axios.isCancel(error)) return await Promise.reject(error);

   if (error?.config?.skipGlobalErrorHandling) {
      return await Promise.reject(error);
   }

   if (!error?.response) {
      router.push({
         path: '/error',
         query: {
            error_code: i18n.global.t('errors.error'),
            error_title: i18n.global.t('generic.feedback.something-went-wrong'),
            error_message: `${isDev ? `${JSON.stringify(error)}` : i18n.global.t('generic.feedback.contact-support')}`,
            error_action: 'refresh',
         },
      });

      return await Promise.reject(error);
   }

   const { status } = error.response;

   if (status === 401) {
      router.push({
         path: '/error',
         query: {
            error_code: '401',
            error_title: i18n.global.t('errors.account-not-found'),
            error_message: `${isDev ? `${JSON.stringify(error)}` : i18n.global.t('generic.account-not-found-description')}`,
            error_action: 'logout',
         },
      });
   }

   return await Promise.reject(error);
};

export { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors };
